// removed by extract-text-webpack-plugin
module.exports = {"content":"style__content__3-7IS","parentContainer":"style__parentContainer__7ftiQ","stratGroup":"style__stratGroup__2NYq8","itemGroup":"style__itemGroup__2WLeI","result":"style__result__1JNJE","resultItem":"style__resultItem__3xQ0T","codeText":"style__codeText__1vUgU","codeTextLarge":"style__codeTextLarge__2AUtL","submitResult":"style__submitResult__2GUXx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PermutedBlocks/style.css
// module id = 580
// module chunks = 0